import * as ngCore from '@angular/core'
import { TypeChecker } from '@attain-apps/type-guards'

import * as input from '../../../../input'
import * as plugin from '../../../ec-plugin'
import { AtnDsTableStore } from '../../../store'

@ngCore.Component({
  imports: [input.search.Component],
  selector: 'embedded-search',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link AtnDsTableStore} */
  public readonly store = ngCore.inject(AtnDsTableStore)

  /** @see {@link plugin.Config.search} */
  public readonly searchConfigSg = ngCore.computed(
    (_pluginConfig = this.store.pluginConfigSg()) =>
      TypeChecker.isObject(_pluginConfig?.search)
        ? _pluginConfig.search
        : undefined,
  )

  public readonly searchValueSg = ngCore.computed(
    (_plugin = this.store.pluginSg()) =>
      _plugin?.collection.plugins.currentListPlugin.appliedParams.selectors.search.asSignal(),
  )

  public searchInputChangeHandler(searchValue: string | undefined) {
    const _plugin = this.store.pluginSg()

    _plugin?.collection.plugins.currentListPlugin.appliedParams.actions.setSearch
      .from('Table.SearchInput.Changed')
      .dispatch(searchValue)
  }
}
